"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const firestore_1 = require("@react-query-firebase/firestore");
const firestore_2 = require("firebase/firestore");
const keyFactory_1 = require("../keyFactory");
function useGuardiaSuscriptionModal(firestore, queryOptions) {
    const subscriptionRef = (0, firestore_2.doc)(firestore, `parametros/${process.env.NEXT_PUBLIC_COUNTRY}/modals/checkout_guardia`);
    return (0, firestore_1.useFirestoreDocumentData)(keyFactory_1.FirestoreKeys.Guardia({
        name: "Suscription",
        path: `parametros/${process.env.NEXT_PUBLIC_COUNTRY}/modals/checkout_guardia`
    }, []), subscriptionRef, {}, queryOptions);
}
exports.default = useGuardiaSuscriptionModal;
